module.exports = __webpack_public_path__ + "img/distictmedia.83db8b35.png";